import React from 'react'
import PropTypes from 'prop-types'
import { EQUIPMENT_MESSAGE } from '@gymaholic/packages'
import PageSubTitle from 'components/Page/Page.SubTitle'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import useIntl from 'modules/component/utils/hooks/useIntl'
import ExerciseChip from 'pages/Exercise/components/Chip'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  equipmentNeeded: {
    id: 'Exercise.equipmentNeeded',
    defaultMessage: 'Equipment needed'
  }
})

export function ExerciseEquipment ({
  equipment
}) {
  const intl = useIntl()

  return (
    <View mt={2}>
      <PageSubTitle style={{ marginBottom: 0 }}>
        {formatMessageIntlUtil(intl, messages.equipmentNeeded)}
      </PageSubTitle>
      <View
        row
        mt='10px'
        mb
        style={{ flexWrap: 'wrap' }}
        jc
      >
        {equipment.map((equipmentId, index) => (
          <ExerciseChip
            key={index}
            text={formatMessageIntlUtil(intl, EQUIPMENT_MESSAGE[equipmentId])}
          />
        ))}
      </View>
    </View>
  )
}

ExerciseEquipment.propTypes = {
  equipment: PropTypes.array.isRequired
}
